module.exports = __webpack_public_path__ + "10f9dbf04c350ee0e0d50c9a555602a9.png";